import { RefObject, useCallback, useState } from "react";
import { FlowLayoutState, Page } from "src/components/FlowLayout";
import { useReportingMemoizer, useResettableReportingMemoizer } from "src/hooks/useMemoizer";
import { useStateCallback } from "src/hooks/useStateCallback";

export interface WrappedPage extends Page {
  // we want to attach the ref to the object so that we can reference
  // sibling refs
  focusRef: RefObject<any>;
  scrollRef: RefObject<any>;
}

export default function useFlowLayoutState(): FlowLayoutState {
  const sectionsVisibleState = useStateCallback<Record<string, boolean>>({});
  const wrappedPagesState = useState<WrappedPage[]>([]);
  const wrappedMemo = useReportingMemoizer<any>();

  return {
    sectionsVisibleState,
    wrappedPagesState,
    wrappedMemo,
  };
}

export function useResettableFlowLayoutState(): [FlowLayoutState, () => void] {
  const sectionsVisibleState = useState<Record<string, boolean>>({});
  const wrappedPagesState = useState<WrappedPage[]>([]);
  const [wrappedMemo, resetMemo] = useResettableReportingMemoizer<any>();

  const reset = useCallback(() => {
    sectionsVisibleState[1]({});
    wrappedPagesState[1]([]);
    resetMemo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetMemo]);

  return [
    {
      sectionsVisibleState,
      wrappedPagesState,
      wrappedMemo,
    },
    reset,
  ];
}
